import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { FilesUploadComponent } from '@core/components/files/files-upload/files-upload.component';

import { WysiwygData } from '@core/models/wysiwyg-data.model';

@Component({
  selector: 'core-message-add-form',
  templateUrl: './message-add-form.component.html',
  styleUrls: ['./message-add-form.component.scss'],
})
export class MessageAddFormComponent implements OnInit {
    @ViewChild(FilesUploadComponent) uploader;

    @Input() placeholder: any = '';
    @Input() context: string = 'default'; // this will manage if message form is in app (deafult) or feedback (share)
    @Input() hash: string = ''; // Used in case of context feedback (share)

    @Output() onSubmit = new EventEmitter<any>();
    @Output() onCancel = new EventEmitter<any>();

    public files:any [] = [];
    public buttonDisabled:boolean = true;
    public uploading: boolean = false;
    public dataSend:any;
    public messageFilesUrlPrefix: string = '';
    public messageContent: string = '';

    ngOnInit() {
        // console.debug(" Placeholder ", this.placeholder)
        if(this.context != 'default' && this.context == 'feedback' && this.hash != ''){
            this.messageFilesUrlPrefix = "/web/share/p/feedback/"+this.hash;
        }
    }


    sendMessage(data){
        // Method send message with the textarea and files
        let filesIds = this.files.map((e) => { return e.id; } );
        console.log(" Message to send: ",this.messageContent);
        this.dataSend ={
            message: this.messageContent,
            files: filesIds
        };
        if(this.dataSend.message != '' && this.dataSend.message != undefined && this.dataSend.message != null){
            this.onSubmit.emit(this.dataSend);
        }
    }

    public clean() {
        // console.log("clean form");
        this.messageContent = '';
        this.files = [];
        this.uploader.files.clear();
    }


    cancel(){
        this.clean();
        this.onCancel.emit();
    }

    onMessageChange(msgData: WysiwygData){

        // console.log("onMessageChange form", msgData.html);
        // to update current var of content to make detect changes on cancel.
        this.messageContent = msgData.html; // need to be updated to send to save message
        this.buttonDisabled = false;
        if(msgData.text.trim() == '')
            this.buttonDisabled = true;
    }

}
